export default __webpack_public_path__ + "assets/30ec2354c64ad653ed2889ab9e4130fa.svg";